import { Icon } from "./Icon.tsx";

/** "Delete" icon shared by every permanent-delete button in the app — before this, each one used the 🗑 emoji directly, rendered inconsistently depending on the system font. */
export function TrashIcon() {
  return (
    <Icon>
      <path d="M4 7h16" />
      <path d="M9 7V4h6v3" />
      <path d="M6 7l1 13h10l1-13" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
    </Icon>
  );
}
